import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  /* Below top-right wallet/chain buttons (top: 25px + 44px height + 16px gap) */
  top: 85px;
  right: 20px;
  width: 200px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }

  @media (max-width: 768px) {
    /* On mobile, top-right buttons move to a different position */
    top: 20px;
    right: 15px;
  }

  @media (max-width: 500px) {
    width: 45% !important;
    left: auto !important;
    right: 10px !important;
    top: 10px !important;
    padding: 0 10px 8px 10px;
    background: transparent !important;
    border: none !important;
  }

  @media (max-width: 900px) and (orientation: landscape) {
    width: 200px !important;
    right: 10px !important;
    top: 20px !important;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    width: 200px !important;
    right: 10px !important;
    top: 10px !important;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Total = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  font-weight: bold;
  color: #4da6ff;
  margin-top: 10px;
  padding: 6px 10px;
  background: rgba(128, 128, 128, 0.2);
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 2px;

  span {
    color: #66d9ff;
  }

  @media (max-width: 500px) {
    font-size: 10px;
    margin-top: 6px;
    padding: 4px 8px;
  }

  @media (max-width: 900px) and (orientation: landscape) {
    font-size: 10px;
    white-space: nowrap;
  }
`;
